<template>
  <div class="page-content">
    <div class="table-operations">
      <el-button type="primary" size="mini" @click="handleAdd">
        <i class="el-icon-plus"></i> 新增
      </el-button>
      <el-button
        type="danger"
        size="mini"
        :disabled="!selectedRows.length"
        @click="handleBatchDelete"
      >
        <i class="el-icon-delete"></i> 批量删除
      </el-button>
    </div>

    <el-table
      :data="tableData"
      @selection-change="handleSelectionChange"
      style="margin: 20px 10px; width: calc(100% - 20px)"
      height="calc(100% - 120px)"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column label="序号" type="index" width="80" align="center">
      </el-table-column>
      <el-table-column prop="storageName" label="仓储位置" align="center">
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center">
      </el-table-column>
      <el-table-column prop="enabled" label="启用" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.enabled === 1 ? "启用" : "禁用" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button type="text" size="small" @click="handleView(scope.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div
      class="pagination-wrapper"
      style="padding: 10px 20px; text-align: right"
    >
      <el-pagination
        background
        :page-size="pageSize"
        :current-page="pageNum"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="仓储位置名称" prop="storageName">
          <el-input
            v-model="form.storageName"
            placeholder="请输入仓储位置名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-switch
            v-model="form.enabled"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看弹窗 -->
    <el-dialog title="查看" :visible.sync="viewDialogVisible" width="480px">
      <div v-if="viewData">
        <p><strong>仓储位置名称：</strong>{{ viewData.storageName }}</p>
        <p>
          <strong>启用：</strong>{{ viewData.enabled === 1 ? "启用" : "禁用" }}
        </p>
        <p><strong>创建时间：</strong>{{ formatTime(viewData.createTime) }}</p>
        <p><strong>更新时间：</strong>{{ formatTime(viewData.updateTime) }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="viewDialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";

export default {
  name: "StoragePositions",
  data() {
    return {
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      selectedRows: [],
      dialogVisible: false,
      dialogTitle: "新增仓储位置",
      form: {
        storageName: "",
        enabled: 1,
      },
      rules: {
        storageName: [
          { required: true, message: "请输入仓储位置名称", trigger: "blur" },
        ],
      },
      viewDialogVisible: false,
      viewData: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(page = this.pageNum) {
      this.pageNum = page;
      axios
        .post(baseUrl + "/api/basic/storage-location/list-page", {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then((res) => {
          // API shape example:
          // { code, msg, data: { list: [...], totalCount, page, pageSize } }
          const payload =
            (res && res.data && (res.data.data || res.data)) || {};
          const list = Array.isArray(payload.list)
            ? payload.list
            : Array.isArray(payload.records)
            ? payload.records
            : [];
          this.tableData = list.map((item) => ({
            ...item,
            enabled:
              typeof item.enabled === "string"
                ? Number(item.enabled)
                : item.enabled,
          }));
          this.total =
            Number(
              payload.totalCount || payload.total || this.tableData.length
            ) || 0;
          this.pageNum =
            Number(payload.page || this.pageNum) || this.pageNum;
          this.pageSize =
            Number(payload.pageSize || this.pageSize) || this.pageSize;
        })
        .catch((err) => {
          console.error("fetch storage locations failed", err);
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchData(1);
    },
    handleCurrentChange(page) {
      this.fetchData(page);
    },
    handleAdd() {
      this.dialogTitle = "新增仓储位置";
      this.form = {
        storageName: "",
        enabled: 1,
      };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogTitle = "编辑仓储位置";
      this.form = {
        storageName: row.storageName,
        enabled: row.enabled,
        id: row.id,
      };
      this.dialogVisible = true;
    },
    handleView(row) {
      const id = row.id;
      axios
        .post(baseUrl + "/api/basic/storage-location/detail/" + id)
        .then((res) => {
          this.viewData = res.data || {};
          this.viewDialogVisible = true;
        });
    },
    handleBatchDelete() {
      this.$confirm(
        `确认删除选中的 ${this.selectedRows.length} 个仓储位置?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const ids = this.selectedRows.map((r) => r.id);
          axios
            .post(baseUrl + "/api/basic/storage-location/delete-batch", ids)
            .then(() => {
              this.$message.success("删除成功");
              this.fetchData(1);
            });
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const isEdit = !!this.form.id;
          const url =
            baseUrl +
            (isEdit
              ? "/api/basic/storage-location/edit"
              : "/api/basic/storage-location/add");
          axios.post(url, this.form).then(() => {
            this.$message.success(isEdit ? "编辑成功" : "新增成功");
            this.dialogVisible = false;
            this.fetchData(1);
          });
        }
      });
    },
    formatTime(val) {
      if (!val) return "";
      // try to print simple string for objects or leave value if string
      if (typeof val === "string") return val;
      try {
        return new Date(val).toLocaleString();
      } catch (e) {
        return String(val);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-content {
  height: 70vh;
}

.dialog-footer {
  text-align: right;
}

.pagination-wrapper {
}
</style>
